var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resolveLayoutVariant,{tag:"component",class:("skin-variant--" + _vm.appSkinVariant)},[_c('div',[_c('loader',{attrs:{"visible":_vm.loading}}),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }